module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/main-categories-icons/23-6ca8d423d97cd73d10826214d8eb865b.svg";